import { RootState } from 'src/types/RootState';

export function getIsPending(state: RootState): boolean {
  return state.saveProject.status?.state === 'pending';
}
